import React, {useEffect, useMemo, useState} from 'react';
import {TouchableOpacity, View} from 'react-native';
import Ionicons from 'react-native-vector-icons/Ionicons';
import SlideModal from '@/Atoms/SlideModal';
import CCText from '@/Atoms/CCText';
import CCTextInput from '@/Atoms/CCTextInput';
import CCButton from '@/Atoms/CCButton';
import Dropzone from 'react-dropzone';
import styles from './styles';
import Spacer from '@/Atoms/Spacer';
import {FontSizes, vs} from '@/Utils/Dimensions';
import CCColors from '@/Utils/CCColors';
import useUploadSupportApi from '@/Hooks/GetSupportModalApi/useUploadSupportApi';
import CCSelect from '@/Atoms/CCSelect';
import AsyncSelect from 'react-select/async';
import Box from '@/Atoms/Box';
import useGetIssueCategories, {
  IssueCategory,
} from '@/Hooks/GetSupportModalApi/useGetIssueCategories';
import {formatDateToDDMMYYYY, formatTimeHHMM} from '@/Utils/CommonUtils';
import {useNavigation} from '@react-navigation/native';
import {ScreenName} from '@/navigators/StackConstants';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';

export const ModalContent = ({
  success,
  renderSuccess,
  message,
  setMessage,
  bugType,
  bugCategory,
  setBugType,
  setBugCategory,
  communicationType,
  setCommunicationType,
  file,
  handleFileChange,
  handleDrop,
  errorMessage,
  setFile,
  isImage,
  handleSubmit,
  issueCategories,
  isLoading,
}) => {
  const [subCategoryOptions, setSubCategoryOptions] = useState<any>([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState<any>(null);
  const defaultOptions =
    issueCategories && typeof issueCategories === 'object'
      ? Object.keys(issueCategories).map(key => ({
          label: key,
          value: key,
        }))
      : [];

  const loadOptions = (inputValue, callback) => {
    const filtered =
      defaultOptions.filter(opt =>
        opt.label.toLowerCase().includes(inputValue.toLowerCase()),
      ) || [];
    callback(filtered);
  };
  const handleChange = (selectedOption: any) => {
    setBugType(selectedOption || null);
    setBugCategory(null);
    setSelectedSubCategory(null);

    if (selectedOption && issueCategories[selectedOption?.value]) {
      const subCats =
        issueCategories[selectedOption?.value]?.sub_categories || [];

      const formattedSubCats = subCats?.map(item => {
        const [key, value] = Object.entries(item)[0];
        return {label: value, value: key};
      });
      setSubCategoryOptions(formattedSubCats);
    } else if (!selectedOption) {
      setSelectedSubCategory(null);
      setBugCategory(null);
    }
  };
  console.log(bugCategory, 'bugCategory');

  const handleSubCategoryChange = (selectedOption: any) => {
    if (selectedOption) {
      setBugCategory(selectedOption?.value);
      setSelectedSubCategory(selectedOption);
    } else {
      setBugCategory(null);
      setSelectedSubCategory(null);
    }
  };
  const selectedCategory = bugType;
  return (
    <View style={styles.modalBackground}>
      {success ? (
        renderSuccess()
      ) : (
        <>
          <View style={{flexDirection: 'row'}}>
            <CCText fontWeight="bold" style={styles.inputLabelStyle}>
              Issue Type
            </CCText>
            <CCText
              fontWeight="bold"
              color={CCColors?.Red}
              style={styles.inputLabelStyle}>
              *
            </CCText>
          </View>
          <AsyncSelect
            cacheOptions={false}
            loadOptions={loadOptions}
            defaultOptions={defaultOptions}
            value={selectedCategory}
            onChange={handleChange}
            isLoading={isLoading}
            noOptionsMessage={() => null}
            placeholder={
              <Box
                flexDirection="row"
                gap={5}
                justifyContent="flex-start"
                alignItems="center">
                <CCText
                  fontSize={FontSizes[14]}
                  color={CCColors.TextColor.Grey}>
                  Choose issue type
                </CCText>
              </Box>
            }
            styles={{
              option: (provided, state) => ({
                ...provided,
                borderBottom: `1px solid ${CCColors.BorderLight}`,
                padding: 8,
              }),
              menu: provided => ({
                ...provided,
                maxHeight: '150px',
                overflowY: 'auto',
              }),
              menuList: provided => ({
                ...provided,
                maxHeight: '150px',
                borderBottomColor: CCColors.BorderLight,
                borderBottomWidth: 1,
                overflowY: 'auto',
              }),
            }}
            isClearable
          />
          <View style={{flexDirection: 'row'}}>
            <CCText fontWeight="bold" style={styles.inputLabelStyle}>
              Issue Category
            </CCText>
            <CCText
              fontWeight="bold"
              color={CCColors?.Red}
              style={styles.inputLabelStyle}>
              *
            </CCText>
          </View>
          <AsyncSelect
            cacheOptions={false}
            loadOptions={(inputValue, callback) => {
              const filtered =
                subCategoryOptions?.filter(opt =>
                  opt?.label
                    ?.toLowerCase()
                    ?.includes(inputValue?.toLowerCase()),
                ) || [];
              callback(filtered);
            }}
            defaultOptions={subCategoryOptions}
            value={selectedSubCategory}
            onChange={handleSubCategoryChange}
            isLoading={isLoading}
            noOptionsMessage={() => null}
            placeholder={
              <Box
                flexDirection="row"
                gap={5}
                justifyContent="flex-start"
                alignItems="center">
                <CCText
                  fontSize={FontSizes[14]}
                  color={CCColors.TextColor.Grey}>
                  Choose issue category
                </CCText>
              </Box>
            }
            styles={{
              option: (provided, state) => ({
                ...provided,
                borderBottom: `1px solid ${CCColors.BorderLight}`,
                padding: 8,
              }),
              menu: provided => ({
                ...provided,
                maxHeight: '150px',
                overflowY: 'auto',
              }),
              menuList: provided => ({
                ...provided,
                maxHeight: '150px',
                borderBottomColor: CCColors.BorderLight,
                borderBottomWidth: 1,
                overflowY: 'auto',
              }),
            }}
            isClearable
          />
          <View style={styles.attachmentContainer}>
            <View style={styles.labelRow}>
              <CCText fontWeight="bold" style={styles.inputLabelStyle}>
                Attachment
              </CCText>
              <CCText fontSize={12} style={styles.inputLabelStyle}>
                PNG/JPEG, Video max 15MB
              </CCText>
            </View>
            <View style={styles.inputWrapper}>
              {file ? (
                <>
                  <Ionicons
                    name={isImage ? 'image-outline' : 'play-circle-outline'}
                    size={20}
                  />
                  <CCText style={styles.fileName}>{file.name}</CCText>
                  <View style={styles.deleteWrapper}>
                    <Ionicons
                      name="trash-outline"
                      size={16}
                      style={styles.deleteIcon}
                      onPress={() => setFile(null)}
                    />
                  </View>
                </>
              ) : (
                <>
                  <CCText
                    style={styles.inputField}
                    onPress={() =>
                      document.getElementById('fileInput')?.click()
                    }>
                    Attach a file
                  </CCText>
                  <CCButton
                    onPress={() =>
                      document.getElementById('fileInput')?.click()
                    }>
                    <CCText style={styles.browseText}>Browse</CCText>
                  </CCButton>
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.png,.mp4,.avi,.mpeg"
                    style={{display: 'none'}}
                    id="fileInput"
                    onChange={handleFileChange}
                  />
                </>
              )}
            </View>
            {errorMessage && (
              <CCText style={{color: CCColors.Red}}>{errorMessage}</CCText>
            )}
          </View>
          <View style={{flexDirection: 'row'}}>
            <CCText fontWeight="bold" style={styles.inputLabelStyle}>
              Way to contact you
            </CCText>
          </View>
          <CCSelect
            style={styles.input}
            label=""
            value={communicationType}
            onValueChange={setCommunicationType}
            placeholder={'Select an option'}
            items={[
              {label: 'Call', value: 'Call'},
              // {label: 'Whatsapp', value: 'Whatsapp'},
              {label: 'Only in Caissa', value: 'Only in Caissa'},
            ]}
          />
          <View style={{flexDirection: 'row'}}>
            <CCText fontWeight="bold" style={styles.inputLabelStyle}>
              Describe the Issue
            </CCText>
            <CCText
              fontWeight="bold"
              color={CCColors?.Red}
              style={styles.inputLabelStyle}>
              *
            </CCText>
          </View>
          <CCTextInput
            style={styles.input}
            placeholder="Add details about issue"
            value={message}
            onChangeText={setMessage}
            multiline={true}
            numberOfLines={4}
            textAlignVertical="top"
          />

          {/* {!file ? (
          <Dropzone
            accept={{
              'image/*': ['.jpg', '.jpeg', '.png'],
              'video/*': ['.mp4', '.avi', '.mpeg'],
            }}
            maxFiles={1}
            onDrop={handleDrop}>
            {({getRootProps, getInputProps}) => (
              <>
                <div {...getRootProps()} style={styles.uploadFiles}>
                  <input {...getInputProps()} style={{display: 'none'}} />
                  <Ionicons name="cloud-upload-outline" size={50} />
                  <Spacer spacing={vs(12)} />
                  <CCText style={styles.uploadText}>
                    Drag and drop file {'\n'}or{' '}
                    <CCText style={{color: CCColors?.Green}}>click here</CCText>{' '}
                    to select file
                  </CCText>
                </div>
                {!errorMessage && (
                  <CCText color={CCColors.TextColor?.Primary}>
                    PNG/JPEG, Video max 15MB
                  </CCText>
                )}
                {errorMessage && (
                  <CCText style={{color: CCColors?.Red}}>{errorMessage}</CCText>
                )}
                <Spacer spacing={vs(20)} />
              </>
            )}
          </Dropzone>
        ) : (
          <>
            <View style={[styles.uploadFiles]}>
              <Ionicons
                name={isImage ? 'image-outline' : 'play-circle-outline'}
                size={100}
              />
              <Spacer spacing={vs(5)} />
              <CCText textAlign="center" style={{width: '80%'}}>
                {file.name}
              </CCText>
              <Ionicons
                name="trash-outline"
                size={20}
                style={styles.deleteIcon}
                onPress={() => setFile(null)}
              />
            </View>
            <CCText color={CCColors.Green}>
              {isImage ? 'Image' : 'Video'} uploaded successfully
            </CCText>
            <Spacer spacing={vs(20)} />
          </>
        )} */}

          {/* <Spacer spacing={vs(20)} /> */}
          <View style={styles.button}>
            <CCButton
              stretched
              disabled={!message || !bugType?.value || !bugCategory}
              titleStyle={{color: CCColors.TextColor.Primary, padding: 15}}
              onPress={handleSubmit}>
              Submit
            </CCButton>
          </View>
        </>
      )}
    </View>
  );
};

const SupportModal = ({openModal, handleClose}) => {
  const navigation = useNavigation();
  const {isMobileOrTab} = useMediaQuery();
  const [message, setMessage] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const [bugType, setBugType] = useState(null);
  const [bugCategory, setBugCategory] = useState(null);
  const [communicationType, setCommunicationType] = useState('');
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [issueCategories, setIssueCategories] = useState([]);

  const [ticketId, setTicketId] = useState<number | null>(null);
  const [commDate, setCommDate] = useState<string | null>(null);

  const {mutate: submitSupportTicket} = useUploadSupportApi(
    data => {
      setTicketId(data?.data?.issue_id || null);
      setCommDate(data?.data?.comm_sla || null);
      setSuccess(true);
    },
    error => {
      setErrorMessage('Failed to submit support ticket');
    },
  );

  const {mutate: getIssueCategories, isLoading} = useGetIssueCategories(
    data => {
      const categories = data?.data || [];
      setIssueCategories(categories);
    },
    error => {
      console.error('Failed to fetch issue categories:', error);
    },
  );

  useEffect(() => {
    if (openModal) {
      getIssueCategories();
    }
  }, [openModal]);

  const isImage = useMemo(() => file && file.type.startsWith('image'), [file]);

  const handleDrop = (acceptedFiles: File[]) => {
    const acceptedFile = acceptedFiles[0];
    const fileSizeMB = acceptedFile.size / (1024 * 1024);

    const isValidFileType = ScreenName?.SupportTicket;
    acceptedFile.type.startsWith('image') ||
      acceptedFile.type.startsWith('video');
    const isValidSize = fileSizeMB <= 15;

    if (!isValidFileType || !isValidSize) {
      setFile(null);
      setErrorMessage(
        'File contains an unknown or unsupported file type, or exceeds the size limit of 15MB',
      );
    } else {
      setFile(acceptedFile);
      setErrorMessage(null);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (!selectedFile) return;

    const fileSizeMB = selectedFile.size / (1024 * 1024);
    const isValidFileType =
      selectedFile.type.startsWith('image') ||
      selectedFile.type.startsWith('video');
    const isValidSize = fileSizeMB <= 15;

    if (!isValidFileType || !isValidSize) {
      setFile(null);
      setErrorMessage('Invalid file type or exceeds 15MB size limit.');
    } else {
      setFile(selectedFile);
      setErrorMessage(null);
    }
  };

  const handleSubmit = () => {
    if (!message || !bugType) {
      setErrorMessage('Both bug type and description are required');
      return;
    }

    setErrorMessage(null);

    const payload: any = {
      bug_type: bugCategory, // sub category id
      description: message,
      communication_type: communicationType,
    };

    if (file) {
      payload.file = file;
    }

    submitSupportTicket(payload);

    setMessage('');
    setFile(null);
    setBugType(null);
    setBugCategory(null);
    setCommunicationType('');
  };

  const renderSuccess = () => (
    <View style={styles.successContainer}>
      <Ionicons
        name="checkmark-circle"
        size={100}
        color={CCColors?.Green}
        style={styles.successIcon}
      />
      <Spacer spacing={vs(10)} />
      <CCText style={styles.modalTitle}>We have received your query</CCText>
      <Spacer spacing={vs(10)} />
      <CCText style={styles.successText}>
        Thank you for submitting your issue. Your ticket ID is {ticketId}. Our
        team will reach out to you before the mentioned SLA time{' '}
        {commDate
          ? `${formatDateToDDMMYYYY(commDate)} ${formatTimeHHMM(commDate)}`
          : '--'}
        .
      </CCText>
      <Spacer spacing={vs(20)} />
      <View style={styles.infoRow}>
        <View style={styles.infoBox}>
          <CCText fontSize={20} color={CCColors.Primary.Brown}>
            #
          </CCText>
          <View style={styles.verticalLine} />
          <View>
            <CCText
              fontSize={FontSizes[12]}
              color={CCColors?.TextColor?.LightGrey}>
              Ticket ID
            </CCText>
            <CCText
              fontSize={FontSizes[12]}
              color={CCColors?.TextColor?.Primary}>
              {ticketId}
            </CCText>
          </View>
        </View>
        <View style={styles.infoBox}>
          <Ionicons
            name="time-outline"
            size={20}
            color={CCColors.Primary.Brown}
          />
          <View style={styles.verticalLine} />
          <View>
            <CCText
              fontSize={FontSizes[12]}
              color={CCColors?.TextColor?.LightGrey}>
              Ticket SLA
            </CCText>
            <CCText
              fontSize={FontSizes[12]}
              color={CCColors?.TextColor?.Primary}>
              {formatDateToDDMMYYYY(commDate)} | {formatTimeHHMM(commDate)}
            </CCText>
          </View>
        </View>
      </View>
      <Spacer spacing={vs(25)} />
      <View style={styles.buttonRow}>
        <CCButton
          onPress={() => {
            handleClose();
            navigation.navigate(ScreenName?.SupportTicket);
          }}
          style={styles.viewTicketBtn}
          contentContainerStyle={{paddingVertical: 12, paddingHorizontal: 50}}
          titleStyle={{
            fontSize: FontSizes[16],
            color: CCColors?.TextColor?.Dark,
          }}>
          View Ticket
        </CCButton>
        <CCButton
          onPress={() => handleClose()}
          style={styles.okayBtn}
          contentContainerStyle={{paddingVertical: 12, paddingHorizontal: 50}}
          titleStyle={{
            fontSize: FontSizes[16],
            color: CCColors?.TextColor?.Dark,
          }}>
          Okay
        </CCButton>
      </View>
      <Spacer spacing={vs(20)} />
    </View>
  );

  useEffect(() => {
    if (!openModal) {
      setMessage('');
      setFile(null);
      setBugType(null);
      setBugCategory(null);
      setSuccess(false);
      setErrorMessage(null);
      setTicketId(null);
      setCommDate(null);
    }
  }, [openModal]);

  return (
    <SlideModal
      type={isMobileOrTab ? 'bottom' : 'center'}
      visible={openModal}
      onClose={handleClose}
      customStyle={{width: '45%', height: isMobileOrTab ? '90%' : ''}}
      modalHeaderTitle={!success ? 'Need assistance' : ''}
      modalHeaderRight={
        !success ? (
          <TouchableOpacity
            onPress={() => {
              handleClose();
              navigation.navigate(ScreenName?.SupportTicket);
            }}>
            <CCText color={CCColors?.Green}>View all tickets</CCText>
          </TouchableOpacity>
        ) : (
          ''
        )
      }>
      <ModalContent
        success={success}
        renderSuccess={renderSuccess}
        message={message}
        setMessage={setMessage}
        bugType={bugType}
        setBugType={setBugType}
        bugCategory={bugCategory}
        setBugCategory={setBugCategory}
        communicationType={communicationType}
        setCommunicationType={setCommunicationType}
        file={file}
        handleFileChange={handleFileChange}
        handleDrop={handleDrop}
        errorMessage={errorMessage}
        setFile={setFile}
        isImage={isImage}
        handleSubmit={handleSubmit}
        issueCategories={issueCategories || []}
        isLoading={isLoading}
      />
    </SlideModal>
  );
};

export default SupportModal;
